module.exports = __webpack_public_path__ + "img/组 177.704b865b.png";